import { Row, Col } from 'react-bootstrap';
import CartItemRow from './CartItemRow';

const RenderSection = ({title, items}) => (
  <div className="section">
    <Row>
      <Col>
        <h5>{title}</h5>
      </Col>
    </Row>
    <div className="section-items">
      {items.map((item, index) => (
        <CartItemRow key={`${title}-${index}`} item={item} index={index} title={title} />
      ))}
    </div>
  </div>
);

export default RenderSection;
